module.exports = __webpack_public_path__ + "static/media/vk-logo-orig.1e5090aa.png";